export interface RotateNudgeHandle {
  destroy(): void;
}

const QUERY = '(orientation: portrait) and (max-width: 720px)';

const SVG_PHONE = `
<svg width="64" height="64" viewBox="0 0 64 64" fill="none" aria-hidden="true">
  <rect x="20" y="6" width="24" height="42" rx="3"
        stroke="currentColor" stroke-width="2" />
  <rect x="28" y="42" width="8" height="2" rx="1" fill="currentColor" />
  <path d="M50 22 a18 18 0 0 1 -18 30" stroke="currentColor"
        stroke-width="2" fill="none" stroke-linecap="round" />
  <path d="M30 50 l4 4 l-6 0 l0 -6 z" fill="currentColor" />
</svg>`;

/**
 * Fullscreen overlay shown only on phones held in portrait. Engine-agnostic —
 * plain DOM. Call once near boot; handle.destroy() to remove.
 */
export function mountRotateNudge(): RotateNudgeHandle {
  const overlay = document.createElement('div');
  overlay.setAttribute('data-rotate-nudge', '');
  overlay.setAttribute('data-visible', 'false');
  overlay.innerHTML = `
    <div class="rotate-nudge-card">
      ${SVG_PHONE}
      <div class="rotate-nudge-text">Rotate your device</div>
    </div>`;
  document.body.appendChild(overlay);

  const mql = typeof window.matchMedia === 'function' ? window.matchMedia(QUERY) : null;
  const apply = (matches: boolean): void => {
    overlay.setAttribute('data-visible', matches ? 'true' : 'false');
  };
  const handler = (e: MediaQueryListEvent | { matches: boolean }): void => apply(e.matches);

  if (mql) {
    apply(mql.matches);
    mql.addEventListener('change', handler as (e: MediaQueryListEvent) => void);
  }

  return {
    destroy(): void {
      if (mql) {
        mql.removeEventListener('change', handler as (e: MediaQueryListEvent) => void);
      }
      overlay.remove();
    },
  };
}
